/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Charge Level Icon component.
 */
const DropdownArrowIcon = (color = dlsColor('darkestBlue')) => {
  const {iconColor} = useIconDLS(color);
  return (
    <svg width='11' height='5' viewBox='0 0 11 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.021 0L5.01056 5L0.000116348 -1.19498e-07L10.021 0Z' fill={iconColor} />
    </svg>
  );
};

export default React.memo(DropdownArrowIcon);
